import LinkIcon from '@atlaskit/icon/core/link';
import * as React from 'react';

export function SvgLink() {
  return <LinkIcon label="" testId="ads-refreshed-icon" />;
}
